// C:\Helpdesk\frontend\src\components/PolicyPage.js
import React from 'react';
import { Link } from 'react-router-dom';
import '../layout/MainLayout/layout.css';

const PolicyPage = ({ title, lastUpdated, children }) => {
  return (
    <div className="policy-page">
      <div className="policy-header">
        <h1>{title}</h1>
        <p className="last-updated">Last updated: {lastUpdated}</p>
      </div>
      
      <div className="policy-content">
        {children}
      </div>
      
      <div className="policy-footer">
        <Link to="/Dashboard" className="back-home">← Back to Home</Link>
      </div>
    </div>
  );
};

export default PolicyPage;